<div>
    @if (renderFiscalYearComponent()) {
        <div class="flex">
            <app-organization-year-select></app-organization-year-select>
        </div>
    }
    
    <ng-content></ng-content>
</div>
